import { Vue, Ref, Prop, Emit, Component } from 'vue-property-decorator'
import {
    initialPaymentMethodModalState,
    PaymentMethodModalState
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/components/payment-method-modal/payment-method-modal.model'
import {
    PaymentMethodCreateRequest,
    PaymentMethodPatchInBatchRequest,
    PaymentMethodResponse
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'

@Component
export default class PaymentMethodModal extends Vue {
    @Ref() readonly paymentMethodModal!: any

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): PaymentMethodCreateRequest {
        const { active, code, name } = this.state
        return { active, code, name }
    }

    @Emit()
    update(): PaymentMethodPatchInBatchRequest {
        return this.state
    }

    state: PaymentMethodModalState
    constructor() {
        super()
        this.state = initialPaymentMethodModalState()
    }

    async show(paymentMethod?: PaymentMethodResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialPaymentMethodModalState()
        if (paymentMethod) {
            this.state = paymentMethod
        }
        this.paymentMethodModal.show()
    }

    hide() {
        this.paymentMethodModal.hide()
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    private get _updateMode(): boolean {
        return (this.state.id !== -1)
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this._updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
